import React from 'react';
import PropTypes from 'prop-types';

class StatefulSubmitButton extends React.Component {
  render () {
    const { value, children, className, ...others } = this.props;
    return (
      <button
        type="submit"
        className={`${className} btn-block btn--stateful `}
        {...others}
        >
        { value ?
          <span>{value}</span> :
          <span>{children}</span>
        }
        <span>
          <span className="pace-loading" style={{ display: 'inline-block', verticalAlign: 'middle', margin: '0 10px 0 0' }}></span>
          <span>Please Wait...</span>
        </span>
      </button>
    );
  }
}


StatefulSubmitButton.defaultProps = {
  className: 'btn-green',
};

StatefulSubmitButton.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
};

export default StatefulSubmitButton;



// WEBPACK FOOTER //
// ./src/common/views/StatefulSubmitButton.js